import React from 'react';
import ExportButton from './ExportButton';

const ChartWithExport = ({ 
  chartId, 
  chartName, 
  children,
  showExportButton = true,
  formats = ['png'],
  exportPosition = 'top-right', // top-right, top-left, bottom-right, bottom-left
  className = ""
}) => {
  if (!showExportButton) {
    return <div id={chartId} className={className}>{children}</div>;
  }

  const getExportButtonClasses = () => {
    switch (exportPosition) {
      case 'top-left':
        return 'flex items-start justify-between';
      case 'top-right':
        return 'flex items-start justify-between';
      case 'bottom-left':
        return 'flex flex-col';
      case 'bottom-right':
        return 'flex flex-col';
      default:
        return 'flex items-start justify-between';
    }
  };

  const getExportButtonPosition = () => {
    switch (exportPosition) {
      case 'top-left':
        return 'order-first';
      case 'top-right':
        return 'order-last';
      case 'bottom-left':
        return 'order-last self-start';
      case 'bottom-right':
        return 'order-last self-end';
      default:
        return 'order-last';
    }
  };

  const isTopPosition = exportPosition.includes('top');

  return (
    <div id={chartId} className={`${className} space-y-2`}>
      <div className={getExportButtonClasses()}>
        {isTopPosition && (
          <>
            <div className="flex-1">
              {exportPosition === 'top-left' && (
                <div className="mb-2">
                  <ExportButton
                    targetId={chartId}
                    componentName={chartName}
                    formats={formats}
                    size="sm"
                    variant="outline"
                    showIcon={true}
                    showText={true}
                    className="shadow-sm"
                  />
                </div>
              )}
            </div>
            <div className="flex-1">
              {exportPosition === 'top-right' && (
                <div className="flex justify-end mb-2">
                  <ExportButton
                    targetId={chartId}
                    componentName={chartName}
                    formats={formats}
                    size="sm"
                    variant="outline"
                    showIcon={true}
                    showText={true}
                    className="shadow-sm"
                  />
                </div>
              )}
            </div>
          </>
        )}
      </div>
      
      {/* Chart Content */}
      <div className="chart-content">
        {children}
      </div>
      
      {!isTopPosition && (
        <div className="mt-2">
          <div className={`flex ${exportPosition === 'bottom-right' ? 'justify-end' : 'justify-start'}`}>
            <ExportButton
              targetId={chartId}
              componentName={chartName}
              formats={formats}
              size="sm"
              variant="outline"
              showIcon={true}
              showText={true}
              className="shadow-sm"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ChartWithExport;